<!--
  vee-validate の ErrorMessage コンポーネントは1つのメッセージしか表示できないため
  複数エラーメッセージに対応したコンポーネントを用意している
  複数エラーメッセージを表示する際は Field コンポーネントに :bails="false" をする必要があるため注意
  cf. https://vee-validate.logaretm.com/v4/api/field
-->
<template>
  <KeepAlive>
    <component
      :is="as"
      v-for="(message, index) in errors"
      :key="index"
      :class="$attrs.class"
      class="error-message"
    >
      {{ message }}
    </component>
  </KeepAlive>
</template>

<script setup>
defineOptions({
  inheritAttrs: false
})

defineProps({
  errors: {
    type: Array,
    required: false,
    default: () => []
  },
  as: {
    type: String,
    required: false,
    default: 'p'
  }
})
</script>

<style lang="scss" scoped>
.error-message {
  font-size: 1rem;
  line-height: 1.6;
  color: $danger;
}
</style>
